module.exports = __webpack_public_path__ + "static/media/履约保函.b26d1610.docx";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/xieyi/履约保函.docx
// module id = 550
// module chunks = 0